import { createClient } from 'microcms-js-sdk';

export const client = createClient({
  // .envファイルに設定したサービスIDとAPIキーを読み込む
  serviceDomain: process.env.REACT_APP_MICROCMS_API_URL as string,
  apiKey: process.env.REACT_APP_MICROCMS_API_KEY as string,
});
